// Dutch overrides for src/data/projects.js, keyed by project id.
// Only user-facing prose is translated here; ids, slugs, tags, colours,
// asset paths, dates and technology lists stay in the English source.
export const projectsNl = {
  1: {
    title: 'Onboardingwebsite voor stagiairs — thesis Friends of Cartel',
    description:
      'Interactieve onboardingwebsite voor toekomstige stagiairs bij Friends of Cartel: Webflow-prototypes, AI-ondersteunde content en videomodules in één begeleide route van dag één tot eerste project.',
    teaser:
      'Graduaat-thesiscase — interactieve onboardingsite voor stagiairs bij Friends of Cartel, van UX en Webflow-prototype tot motion-gedreven modules.',
    imageAlt:
      'UI van de onboardingwebsite voor stagiairs bij Friends of Cartel — thesis webdesign door Sander Kuyken',
    sector: 'Onderwijs',
    services: 'Experience design, Onboardingstrategie, Motion design',
    caseStudy: {
      challenge:
        'Nieuwe stagiairs bij Friends of Cartel werden ad hoc onboard gebracht, met verspreide docs en geen gedeeld startpunt — traag productief en snel overweldigend.',
      approach:
        'Ik ontwierp één begeleide onboardingroute: Webflow-prototypes, AI-ondersteunde content en korte videomodules, gesequenced tot één helder pad van dag één tot eerste project.',
      result:
        'Een samenhangende onboardingervaring die een rommelige eerste week omzet in een zelfzekere ramp-up op eigen tempo — en een thesiscase over het volledige traject van concept tot presentatie.',
      role: 'Concept, UX, motion & build',
      deliverables: ['UX-flow', 'Webflow-prototype', 'Videomodules', 'Onboardingcontent'],
    },
    relatedLinks: { label: 'Web / UX design' },
  },
  2: {
    title: 'Bilzen-Hoeselt social media motion graphics',
    description:
      'Branded social animatiereeks voor Bilzen-Hoeselt — lokale events vertaald naar korte, punchy motion clips met consistente kleur, typografie en pacing voor de gemeentelijke feeds.',
    imageAlt: 'Frame uit de branded social media motion graphics voor Bilzen-Hoeselt',
    sector: 'Gemeente & toerisme',
    services: 'Social content, Animatieproductie',
    caseStudy: {
      challenge:
        'Bilzen-Hoeselt had korte social motion nodig die lokaal en energiek aanvoelt, zonder eruit te zien als een generieke templatepack.',
      approach:
        'Tijdens mijn stage bij Friends of Cartel bouwde ik branded clips — testen met kleur, typografische accenten en pacing zodat elk event deel bleef van één campagnesysteem.',
      result:
        'Een consistente motiontaal voor gemeentelijke social content die opvalt in de feed en on-brand blijft over alle events heen.',
      role: 'Motion design',
      deliverables: ['Social animatiereeks', 'Branded motionsysteem', 'Typografische accenten'],
    },
    relatedLinks: { label: 'Motion design' },
  },
  3: {
    title: 'Multipharma apotheek motion graphics',
    description:
      'Motion graphics die de diensten van apotheek Multipharma helderder maken: geanimeerde iconen, zachte 3D-accenten en getimede reveals voor social en digitale campagnes.',
    teaser:
      'Apotheekdiensten uitgelegd in motion — heldere iconografie en merkritme, gebouwd voor de social en web van Multipharma.',
    imageAlt: 'Still uit de motion graphics-animatie voor apotheek Multipharma',
    sector: 'Zorg',
    services: 'Motion design, Informatiedesign',
    caseStudy: {
      challenge:
        'Multipharma had motion nodig die apotheekdiensten duidelijker en toegankelijker maakt, zonder klinisch aan te voelen.',
      approach:
        'Ik vertaalde complexe informatie naar heldere animaties met iconografie, subtiele 3D en zachte transities, binnen het team van Friends of Cartel.',
      result:
        'Een motionpakket dat dienstenverhalen sneller scanbaar en beter onthoudbaar maakt over alle digitale touchpoints.',
      role: 'Motion graphics',
      deliverables: ['Motionsequenties', 'Icoonanimatie', 'Social-ready exports'],
    },
    relatedLinks: { label: 'Motion design' },
  },
  4: {
    title: 'RCA Cafe netwerkevent-poster',
    description:
      'Print- en digitale poster voor de RCA Cafe netwerkavond bij Cartel Agency — handgetekende accenten en expressieve typografie voor een speelse eventvibe.',
    imageAlt: 'Posterdesign voor het RCA Cafe netwerkevent',
    sector: 'Events & cultuur',
    services: 'Printdesign, Campagnemateriaal',
    caseStudy: {
      challenge:
        'RCA Cafe had een poster nodig voor een netwerkavond bij Cartel Agency die speels en event-klaar oogt, in print én digitaal.',
      approach:
        'Ik combineerde handgetekende elementen met expressieve typografie zodat de vibe meteen leest, aan de muur en op scherm.',
      result:
        'Print- en digitale postervarianten die als campagne-assets opvallen voor de avond van maart 2025.',
      role: 'Posterdesign',
      deliverables: ['Printposter', 'Digitale variant', 'Handgetekende accenten'],
    },
  },
  5: {
    title: 'Becoland typografische logo-animatie',
    description:
      'Typografie-gedreven logo-animatie voor Becoland met uitgetest ritme, glow en loopframes — klaar voor events en digitale merkmomenten.',
    imageAlt: 'Still uit de typografische logo-animatie voor Becoland',
    sector: 'Food & leisure',
    services: 'Logo-animatie, Brand motion toolkit',
    caseStudy: {
      challenge:
        'Becoland wilde een logo-animatie die leeft online en op events, zonder de richtlijnen van Friends of Cartel te breken.',
      approach:
        'Ik testte ritme, glow en overgangsframes zodat het merkteken leest in korte loops én in langere merkmomenten.',
      result:
        'Een typografie-gedreven logo-animatie die aansluit op de stijlrichtlijnen van mei 2025.',
      role: 'Logo-animatie',
      deliverables: ['Logo-animatie', 'Loopvarianten', 'Event-klare exports'],
    },
    relatedLinks: { label: 'Branding' },
  },
  6: {
    title: 'Palpatine VFX colour grading-studie',
    description:
      'Cinematische VFX-studie die Emperor Palpatine tot leven brengt via colour grading, rotoscoping en het compositen van energie-effecten.',
    imageAlt: 'Palpatine VFX-studie met colour grading en compositing',
    sector: 'Entertainment',
    services: 'Compositing, VFX-experiment',
    caseStudy: {
      challenge:
        'Emperor Palpatine tot leven brengen in een VFX-studie met geloofwaardige grading, rotoscoping en compositing.',
      approach:
        'Ik experimenteerde met kleur, energie-effecten en plate-integratie tot silhouet en kracht helder lazen.',
      result:
        'Een VFX-studie die grading, rotoscoping en compositing-vakwerk toont in één cinematische beat.',
      role: 'VFX & compositing',
      deliverables: ['VFX-shot', 'Colour grade', 'Compositing-passes'],
    },
  },
  7: {
    title: 'Spider-Man VFX camera tracking-experiment',
    description:
      'Kort Spider-Man VFX-experiment dat camera tracking, 3D-websimulatie en getimede impacts combineert in een cinematische loop.',
    imageAlt: 'Still uit het Spider-Man VFX camera tracking-experiment',
    sector: 'Entertainment',
    services: 'Compositing, Motion-exploratie',
    caseStudy: {
      challenge:
        'Superhelden-VFX verkennen in een kort Spider-Man stuk, zonder volledige feature-pipeline.',
      approach:
        'Ik combineerde camera tracking met 3D-websimulatie en getimede impacts zodat het experiment toch cinematisch aanvoelt.',
      result:
        'Een punchy persoonlijk VFX-experiment dat tracking, simulatie en energie laat zien.',
      role: 'VFX-experiment',
      deliverables: ['Getrackte shot', '3D-websimulatie', 'Gecomposite sequentie'],
    },
  },
  8: {
    title: 'Handgemaakte stop-motion kortfilm',
    description:
      'Stop-motionfilm voor een Motion Design-vak — frame-per-frame fotografie, tactiele texturen en licht die het verhaal dragen.',
    imageAlt: 'Frame uit de handgemaakte stop-motion kortfilm',
    sector: 'Onderwijs',
    services: 'Stop-motionproductie, Sound design',
    caseStudy: {
      challenge:
        'Een stop-motionfilm maken waarin tactiele texturen het verhaal leiden, voor een Motion Design-vak.',
      approach:
        'Ik fotografeerde elk frame, stuurde het licht en doseerde de fysieke beweging zodat kleine bewegingen toch bewust lezen.',
      result:
        'Een handgemaakt stop-motionstuk dat geduld, kadrering en materiaalvakwerk toont.',
      role: 'Stop-motion & regie',
      deliverables: ['Stop-motionfilm', 'Framesequentie', 'Setbelichting'],
    },
  },
  9: {
    title: 'Dreaming — audiovisuele edit op Kanye West',
    description:
      'Audiovisueel experiment op Dreaming van Kanye West — beeld, glitch-overlays en typografie gemonteerd op de emotionele boog van de track.',
    imageAlt: 'Still uit de audiovisuele muziekedit Dreaming — track van Kanye West',
    sector: 'Entertainment',
    services: 'Videomontage, Visual effects',
    caseStudy: {
      challenge:
        'Een audiovisueel experiment bouwen op Dreaming van Kanye West dat bewust aanvoelt, geen willekeurige flitscuts.',
      approach:
        'Ik mengde beeld, glitch-achtige overlays en typografische momenten, gemonteerd op de emotionele boog van de track.',
      result:
        'Een muziekgedreven visuele edit met heldere pacing en een consistente, atmosferische attitude.',
      role: 'Visuele edit & regie',
      deliverables: ['Audiovisuele edit', 'Grafische overlays', 'Colour look'],
    },
  },
  10: {
    title: 'Charged lifestyle-huisstijl & advertenties',
    description:
      'Bold lifestyle branding voor Charged: logo, modulaire advertentielayouts en social templates met hoog contrast, zodat veertien deliverables één systeem blijven.',
    imageAlt: 'Charged lifestyle-huisstijl met logo en advertentielayout',
    sector: 'Lifestyle & retail',
    services: 'Huisstijl, Creative direction, Advertising toolkit',
    caseStudy: {
      challenge:
        'Charged had een bold lifestyle-identiteit nodig die herkenbaar blijft over logo, advertenties en social, zonder af te drijven.',
      approach:
        'Ik bouwde een modulair visueel systeem met sterk contrast en herhaalbare layouts zodat veertien deliverables toch één merk blijven.',
      result:
        'Een energiek identiteitssysteem dat schaalt van logo tot campagne-advertenties en consistent blijft.',
      role: 'Branding & campagnedesign',
      deliverables: ['Logo', 'Advertentiesysteem', 'Social templates', 'Merklayouts'],
    },
    relatedLinks: { label: 'Branding' },
  },
  11: {
    title: 'Hasselt Shopping Sundays stadscampagne',
    description:
      'Campagne-identiteit voor de Shopping Sundays van Stad Hasselt — posters, animaties en social posts die Hasselt neerzetten als bruisende maandelijkse ontmoetingsplek.',
    imageAlt: 'Posterdesign voor de Hasselt Shopping Sundays stadscampagne',
    sector: 'Overheid & publieke sector',
    services: 'Campagne-identiteit, Motion assets, Social content',
    caseStudy: {
      challenge:
        'Stad Hasselt had een campagne-identiteit nodig voor de maandelijkse Shopping Sundays die stedelijk, feestelijk en helder werkt in de publieke ruimte.',
      approach:
        'Vertrekkend van doelgroeponderzoek bouwde ik een kleurrijke visuele taal over posters, animaties en social posts.',
      result:
        'Een campagnesysteem dat Hasselt neerzet als bruisende ontmoetingsplek en het event in één oogopslag communiceert.',
      role: 'Campagne-identiteit',
      deliverables: ['Campagne-identiteit', 'Posters', 'Social & motion'],
    },
  },
  14: {
    title: 'Lil Yachty muziekvideo-edit',
    description:
      'Snelle, punchy Lil Yachty muziekedit met frame-perfect ritme, custom transities en handgemaakte overlays afgestemd op de track.',
    imageAlt: 'Frame uit de Lil Yachty muziekvideo-edit',
    sector: 'Entertainment',
    services: 'Muziekvideo-edit, Motion design',
    caseStudy: {
      challenge:
        'Een Lil Yachty edit maken met snelle, punchy cuts die de track versterken in plaats van tegenwerken.',
      approach:
        'Ik verfijnde frame-perfect ritmes, handgemaakte overlays en custom transities voor een strakkere muziekedit-workflow.',
      result:
        'Een scherpere muziekvideo-edit die een duidelijke stap vooruit zet tegenover eerdere cuts.',
      role: 'Videomontage',
      deliverables: ['Muziekedit', 'Custom transities', 'Grafische overlays'],
    },
  },
  15: {
    title: 'Ice Spice social muziekvideo-edit',
    description:
      'Compacte Ice Spice muziekedit die trendy motion presets mixt met custom graphics voor social-native pacing en artiestenenergie.',
    imageAlt: 'Frame uit de Ice Spice social muziekvideo-edit',
    sector: 'Entertainment',
    services: 'Muziekvideo-edit, Motion templates',
    caseStudy: {
      challenge:
        'Variatie creëren binnen een compact Ice Spice-format zonder attitude of leesbaarheid te verliezen.',
      approach:
        'Ik mixte trendy motion presets met custom graphics zodat de edit fris blijft terwijl gezicht en performance primair blijven.',
      result:
        'Een social-native muziekedit met hoge energie en gecontroleerde visuele variatie.',
      role: 'Videomontage',
      deliverables: ['Muziekedit', 'Motion graphics', 'Colour look'],
    },
  },
  16: {
    title: 'Harry Potter-geïnspireerde 3D-slaapkamerset',
    description:
      'Harry Potter–geïnspireerde 3D-omgeving: conceptslaapkamer, volledige setbuild en cinematische belichting van idee tot finale renders.',
    imageAlt: 'Render van de Harry Potter-geïnspireerde 3D-slaapkameromgeving',
    sector: 'Entertainment',
    services: 'Conceptdesign, 3D-visualisatie',
    caseStudy: {
      challenge:
        'Een Harry Potter–geïnspireerde kamer ontwerpen die een volledig proces van concept tot ruimte toont, niet enkel een mooie still.',
      approach:
        'Ik ontwierp een speels slaapkamerconcept, bouwde de set in 3D en belichtte ze voor cinematische leesbaarheid.',
      result:
        'Een environment-stuk dat concept, modelling en presentatie als één pipeline laat zien.',
      role: '3D-environment',
      deliverables: ['Concept', '3D-set', 'Hero renders'],
    },
  },
  17: {
    title: 'Rome & Japan architecturale 3D-studie',
    description:
      'Architecturale sfeerstudie die Rome en Japan samenbrengt — gedetailleerde modelling en belichting die beide culturen herkenbaar houdt.',
    imageAlt: 'Architecturale 3D-sfeerstudie van Rome en Japan',
    sector: 'Visualisatie',
    services: '3D-modelling, Belichting, Rendering',
    caseStudy: {
      challenge:
        'Rome en Japan samenbrengen als contrasterende architecturale sferen in één coherente 3D-studie.',
      approach:
        'Ik modelleerde de structuren met aandacht voor culturele materiaaltaal en sequencede daarna de belichting voor contrast.',
      result:
        'Een studie van twee werelden die beide culturen apart houdt terwijl het vakwerk consistent blijft.',
      role: '3D-environment & art direction',
      deliverables: ['Architecturale modellen', 'Sfeerbelichting', 'Presentatierenders'],
    },
  },
  19: {
    title: 'Space Train sci-fi 3D-environment',
    description:
      'Sci-fi 3D-scène die een Karaska-poster vertaalt naar een verlaten ruimtetreinwagon met materialen en cinematische kadrering.',
    imageAlt: 'Render van de Space Train sci-fi 3D-environment',
    sector: 'Entertainment',
    services: 'Conceptontwikkeling, 3D-illustratie',
    caseStudy: {
      challenge:
        'Een Karaska-poster vertalen naar een geloofwaardige 3D sci-fi Space Train-scène.',
      approach:
        'Ik bouwde een verlaten wagon met surrealistische details, met focus op silhouet, materialen en camerakadrering.',
      result:
        'Een sci-fi environment die het idee van de poster respecteert en toch als eigen 3D-wereld staat.',
      role: '3D-concept & visualisatie',
      deliverables: ['Environmentmodel', 'Materialen', 'Hero renders'],
    },
  },
  20: {
    title: 'PXL Esports rebranding & platform-UI',
    description:
      'PXL Esports rebranding met huisstijl, UI-componenten, app-flows en studentgericht promotiemateriaal tot en met prototypes.',
    teaser:
      'PXL Esports rebranding — bold identiteit, UI-systeem en platformdesign voor een esports-community op de campus.',
    imageAlt: 'PXL Esports rebranding en UI van het digitale platform',
    sector: 'Onderwijs',
    services: 'Huisstijl, Productdesign, Campagnemateriaal',
    caseStudy: {
      challenge:
        'PXL Esports had een rebranding nodig die studenten raakt, plus een digitaal platform dat even energiek aanvoelt als de scene erachter.',
      approach:
        'Vertrekkend van analyse en visuele richting bouwde ik een flexibele identiteit en ontwierp ik UI-componenten, app-flows en promomateriaal tot werkende prototypes.',
      result:
        'Een samenhangend merk- en productsysteem voor studenten — van identiteit tot interactieve prototypes — opgeleverd over een traject van zes maanden.',
      role: 'Brand & product designer',
      deliverables: ['Huisstijl', 'UI-componentenset', 'App-flows', 'Campagnemateriaal'],
    },
    relatedLinks: { label: 'Branding' },
  },
  21: {
    title: 'Light Beam minimale typografieposter',
    description:
      'Minimale poster over typografische hiërarchie en zachte lichtbundels — een rustige optische hook met verfijnde printafwerking.',
    imageAlt: 'Light Beam minimale typografieposter',
    sector: 'Conceptueel design',
    services: 'Posterdesign, Conceptexploratie',
    caseStudy: {
      challenge:
        'Typografisch minimalisme verkennen waarbij lichtbundels en zachte schaduwen de drama van de poster dragen.',
      approach:
        'Ik testte hoe lichtbundels inwerken op typografische hiërarchie tot de compositie rustig maar memorabel aanvoelde.',
      result:
        'Een minimale poster met een heldere optische hook en verfijnde productiekwaliteit.',
      role: 'Posterdesign',
      deliverables: ['Key visual', 'Posterlayout', 'Printbestand'],
    },
  },
  22: {
    title: 'Persoonlijk SK logo design',
    description:
      'Persoonlijk logo ontworpen vanuit doelgroeponderzoek en merkwaarden — een geometrisch SK-teken dat werkt in print en digitaal, ook op klein formaat.',
    imageAlt: 'Het persoonlijke SK-logo als merkteken',
    sector: 'Persoonlijk merk',
    services: 'Logo design, Huisstijl',
    caseStudy: {
      challenge:
        'Een persoonlijk logo ontwerpen dat memorabel, modulair en bruikbaar is in print en digitaal.',
      approach:
        'Na doelgroep- en waardenonderzoek schetste ik tientallen geometrische opties en verfijnde ik het teken voor kleine formaten.',
      result:
        'Een simpel, modern embleem dat clean print en werkt over alle web-touchpoints.',
      role: 'Logo design',
      deliverables: ['Primair merkteken', 'Varianten', 'Gebruiksbasics'],
    },
  },
  23: {
    title: 'Abandoned Room sfeervol 3D-interieur',
    description:
      'Gedetailleerd Blender-interieur met focus op storytelling — verweerde materialen, props en belichting die de ruimte bewoond doen aanvoelen.',
    imageAlt: 'Render van het sfeervolle 3D-interieur Abandoned Room',
    sector: 'Visualisatie',
    services: '3D-modelling, Texturing, Belichting',
    caseStudy: {
      challenge:
        'Een Abandoned Room-scène in Blender bouwen waarin storytelling leidt, niet enkel technisch detail.',
      approach:
        'Ik modelleerde meubels, maakte verweerde materialen en belichtte voor narratieve falloff zodat de ruimte bewoond aanvoelt.',
      result:
        'Een sfeervol interieur dat evenzeer als filmstill leest als als 3D-demo.',
      role: '3D-environment',
      deliverables: ['Volledige scène', 'Materialen', 'Hero-belichting'],
    },
  },
  24: {
    title: 'Geïllustreerde filmposterreeks van klassiekers',
    description:
      'Reeks filmposters die klassiekers herdenkt als illustratieve composities — handgetekende lijnen, digitale kleur en heldere titelhiërarchie.',
    imageAlt: 'Geïllustreerde posterreeks van klassieke films',
    sector: 'Entertainment',
    services: 'Illustratie, Posterdesign, Art direction',
    caseStudy: {
      challenge:
        'Klassieke films herdenken als illustratieve postercomposities met één consistente reekstaal.',
      approach:
        'Ik mixte handgetekende lijnen met digitale kleur en legde de hiërarchie vast zodat titel en sfeer altijd eerst landen.',
      result:
        'Een filmposterreeks met illustratief karakter en duidelijk campagne-DNA.',
      role: 'Posterdesign',
      deliverables: ['Posterreeks', 'Illustratiestijl', 'Printexports'],
    },
  },
  25: {
    title: '3D-vlotmodel — klasproject SyntraPXL',
    description:
      '3D-vlot gemodelleerd in 3ds Max en gerenderd in Blender voor SyntraPXL — silhouet, houtmaterialen en presentatie in watercontext.',
    imageAlt: 'Render van het 3D-vlotmodel voor het klasproject bij SyntraPXL',
    sector: 'Game art',
    services: '3D-modelling, Texturing, Belichting',
    caseStudy: {
      challenge:
        'Een vlotscène modelleren en presenteren voor de 3D-les bij SyntraPXL, met geloofwaardige materialen en watercontext.',
      approach:
        'Ik bouwde het vaartuig in 3ds Max en Blender, met focus op silhouet, houtrespons en renderpresentatie.',
      result:
        'Een 3D-klasstuk dat de basis van modelling en rendering toont in één heldere hero still.',
      role: '3D-modelling & rendering',
      deliverables: ['Vlotmodel', 'Materialen', 'Hero render'],
    },
  },
  26: {
    title: 'Posterdesigns voor muziekartiest Breadyz',
    description:
      'Muziekposters voor artiest Breadyz in Photoshop en Illustrator — expressieve typografie en beeld die op afstand leesbaar blijven.',
    imageAlt: 'Posterdesign voor muziekartiest Breadyz',
    sector: 'Music art',
    services: 'Posterdesign, Art direction',
    caseStudy: {
      challenge:
        'Muziekposters ontwerpen voor artiest Breadyz die bewust luid zijn zonder onleesbaar te worden.',
      approach:
        'In Photoshop en Illustrator balanceerde ik expressieve typografie en beeld zodat de artiesteninfo op afstand blijft lezen.',
      result:
        'Posterdesigns met sterke aanwezigheid en een duidelijke visuele attitude voor de artiest.',
      role: 'Posterdesign',
      deliverables: ['Muziekposters', 'Typografische lockups', 'Printbestanden'],
    },
  },
  27: {
    title: 'Schoolproject datavisualisatie-design',
    description:
      'Schoolproject dataviz in Blender en Photoshop — grafiekhiërarchie en dimensionale behandelingen die dichte data toegankelijk maken.',
    imageAlt: 'Grafieken uit het schoolproject datavisualisatie-design',
    sector: 'Datavisualisatie',
    services: 'Datavisualisatie-design, Art direction',
    caseStudy: {
      challenge:
        'Een schoolbrief rond dataviz omzetten naar visuals die informatie uitleggen zonder te verdrinken in grafieken.',
      approach:
        'Met Blender en Photoshop bouwde ik hiërarchie, kleurcodering en dimensionale grafiekbehandelingen.',
      result:
        'Een datavizproject dat dichte informatie toegankelijk en ontworpen doet aanvoelen.',
      role: 'Datavisualisatie',
      deliverables: ['Grafiekvisuals', '3D-databehandelingen', 'Presentatieborden'],
    },
  },
  28: {
    title: 'Friends of Cartel datavisualisatie',
    description:
      'Agency-dataviz voor Friends of Cartel in Illustrator en Photoshop — heldere informatiehiërarchie met verzorgde presentatie.',
    imageAlt: 'Datavisualisatie-design voor Friends of Cartel',
    sector: 'Branding',
    services: 'Datavisualisatie-design, Art direction',
    caseStudy: {
      challenge:
        'Een dataviz-stuk maken voor Friends of Cartel dat on-brand en leesbaar is voor agency-gebruik.',
      approach:
        'In Illustrator en Photoshop ontwierp ik een heldere informatiehiërarchie met vakwerk dat bij Cartel past.',
      result:
        'Een verzorgde dataviz-deliverable die klaar is voor agency-presentatie en storytelling.',
      role: 'Datavisualisatie',
      deliverables: ['Dataviz-layouts', 'Infographic-systeem', 'Exportset'],
    },
  },
  29: {
    title: 'Draak-creature sculpt in ZBrush',
    description:
      'Draak-creature gesculpt in ZBrush voor school — anatomische landmarks, oppervlaktedetail en leesbare turnaround-presentatie.',
    imageAlt: '3D-sculpt van een draak-creature in ZBrush',
    sector: '3D-modelling',
    services: '3D-modelling, Texturing, Belichting',
    caseStudy: {
      challenge:
        'Een draak sculpten die vorm, oppervlak en silhouet helder toont voor een 3D-schoolbrief.',
      approach:
        'In ZBrush bouwde ik de anatomische landmarks en presenteerde ik de creature voor leesbare turnarounds.',
      result:
        'Een creature sculpt die vormtaal en presentatiediscipline aantoont.',
      role: '3D-sculpting',
      deliverables: ['ZBrush-sculpt', 'Turnaround-renders', 'Detailviews'],
    },
  },
  30: {
    title: 'HDRI-belichting — fotorealistische 3D-kamer',
    description:
      'Fotoreële interieurstudie vanuit één HDRI — exposure matching, reflecties en materialen die dezelfde lichtrealiteit delen.',
    imageAlt: 'Fotorealistische 3D-kamer als studie in HDRI-belichting',
    sector: 'Visualisatie',
    services: '3D-modelling, Belichting, Look-dev',
    caseStudy: {
      challenge:
        'Eén HDRI omzetten naar een volledig uitgewerkt fotorealistisch interieur met een consistente lichtrealiteit.',
      approach:
        'Ik matchte exposure, reflecties en propschaal zodat materialen en de dome één lichtwereld delen.',
      result:
        'Een fotoreële kamerstudie die HDRI-belichting en look-dev-precisie aantoont.',
      role: '3D-belichting & look-dev',
      deliverables: ['Belicht interieur', 'HDRI-setup', 'Stillrenders'],
    },
  },
  31: {
    title: 'Beauty Studio Olga webdesign & UI/UX',
    description:
      'Rustige, premium web en UI/UX voor Beauty Studio Olga — huisstijl en interface gericht op moeiteloos boeken op elk toestel.',
    imageAlt: 'Web- en UI/UX-design voor Beauty Studio Olga',
    sector: 'Beauty & wellness',
    services: 'Webdesign, UI/UX-design, Huisstijl',
    caseStudy: {
      challenge:
        'Een schoonheidssalon had een online aanwezigheid nodig die rustig en premium aanvoelt, terwijl boeken en browsen moeiteloos blijven op elk toestel.',
      approach:
        'Ik ontwierp de huisstijl en de interface rond een zachte esthetiek, met een heldere, conversiegerichte structuur waarin boeken centraal staat.',
      result:
        'Een premium aanvoelende site en UI die een zachte look combineert met een makkelijke, moeiteloze route naar de boeking — geloofwaardig en on-brand op elk scherm.',
      role: 'Web & UI/UX designer',
      deliverables: ['Huisstijl', 'Responsive UI', 'Boekingsflow', 'Designsysteem'],
    },
  },
  32: {
    title: 'Loneliness — editorial bookletdesign',
    description:
      'Editorial booklet over isolatie via typografie, beeld en gedoseerde spreads — rustige whitespace met momenten van visuele spanning.',
    imageAlt: 'Typografische spread uit het editorial booklet Loneliness',
    sector: 'Editorial & print',
    services: 'Editorial design, Print, Art direction',
    caseStudy: {
      challenge:
        'Isolatie verkennen in een editorial booklet zonder clichébeeld of onleesbare typografie.',
      approach:
        'Ik ontwierp layout, grid en beeldbehandeling zodat elke spread zijn eigen emotionele ritme draagt, met rustige whitespace en spanning.',
      result:
        'Een printbooklet waarin sfeer en leesbaarheid samenwerken over de volledige paginasequentie.',
      role: 'Editorial design',
      deliverables: ['Bookletlayout', 'Typografisch systeem', 'Printspreads'],
    },
  },
  33: {
    title: '3D-character sculpt — Crown Woman',
    description:
      '3D-characterstudie van high-poly sculpt tot game-ready low-poly — silhouet, topologie en turnarounds voor Crown Woman.',
    imageAlt: 'Turnaround van de 3D-character sculpt Crown Woman',
    sector: 'Game art',
    services: '3D-modelling, Character art, Hi-poly naar low-poly',
    caseStudy: {
      challenge:
        'Crown Woman van een high-poly sculpt naar een clean, game-ready low-poly model brengen zonder het silhouet te verliezen.',
      approach:
        'Ik werkte topologie en vorm uit over meerdere views zodat het design vanuit elke hoek leesbaar blijft.',
      result:
        'Een characterstudie die een volledige hi-poly naar low-poly pipeline documenteert.',
      role: '3D-character / game art',
      deliverables: ['Hi-poly sculpt', 'Low-poly model', 'Turnaround-views'],
    },
  },
  34: {
    title: 'Fabriek naar woning — architecturale visualisatie',
    description:
      'Architecturale visualisatie van een moderne fabriek herdacht als woonruimte — modelling, V-Ray/Vantage renders en een gezamenlijke walkthrough-film.',
    imageAlt: 'Render van de architecturale visualisatie van fabriek naar woonruimte',
    sector: 'Architectuur / game art',
    services: '3D-modelling, Architecturale visualisatie',
    caseStudy: {
      challenge:
        'Een moderne omvorming van fabriek naar woning tonen als archviz die geloofwaardig aanvoelt om in te wonen, niet enkel technisch.',
      approach:
        'Ik modelleerde de architectuur, zette camera’s op menselijke schaal, renderde met V-Ray / Vantage en monteerde samen met collega’s een korte film die sfeer en hergebruik van ruimte verkoopt.',
      result:
        'Een archviz-case met hero stills en een walkthrough-video die de residentiële omvorming uitlegt.',
      role: '3D-modelling, archviz & montage',
      deliverables: ['Architecturaal model', 'Hero stills', 'Walkthrough-video'],
    },
  },
  35: {
    title: '3D- & VFX-demoreel 2026',
    description:
      'Demoreel 2026 bundelt een jaar 3D-modelling, look-dev, archviz en VFX in één gepacete reel voor sollicitaties en portfolio reviews.',
    imageAlt: 'Titelkaart van de 3D- en VFX-demoreel 2026',
    sector: 'Game art',
    services: '3D-modelling, Architecturale visualisatie, Montage',
    caseStudy: {
      challenge:
        'Een jaar aan klas- en persoonlijk 3D/VFX-werk bundelen in een demoreel die recruiters snel kunnen scannen.',
      approach:
        'Ik selecteerde de sterkste shots, gradede voor consistentie en sequencede op pacing — eerst impact, dan variatie in vakwerk.',
      result:
        'Demoreel 2026: een helder skill-overzicht over modelling, look-dev en motion, voor sollicitaties en portfolio.',
      role: 'Montage, grading & shotselectie',
      deliverables: ['Demoreel-film', 'Titelkaart', 'Shotselectie'],
    },
  },
  36: {
    title: 'CPROEF 2026 — 3D-environment showcase',
    description:
      'CPROEF 2026 vrije-keuze 3D-environment: end-to-end modelling en cinematische presentatie voor klasoplevering en portfolio.',
    teaser:
      'Volledige 3D-environment voor CPROEF 2026 — modelling, belichting en cinematische presentatie, van vrije brief tot finale film.',
    imageAlt: 'Render uit de CPROEF 2026 3D-environment showcase',
    sector: 'Game art',
    services: '3D-modelling, Architecturale visualisatie',
    caseStudy: {
      challenge:
        'Voor CPROEF 2026 vrij een 3D-environment kiezen en bouwen die modelling- en presentatievakwerk bewijst.',
      approach:
        'Ik legde een sterk environmentconcept vast, bouwde de ruimte end-to-end en presenteerde ze met een cinematische pass voor de klasoplevering.',
      result:
        'Een afgewerkte environment-case die ownership toont van briefkeuze tot finale render en video.',
      role: '3D-environment',
      deliverables: ['Environmentmodel', 'Hero render', 'Presentatievideo'],
    },
  },
  37: {
    title: 'Persoonlijk logo rework & brandbook',
    description:
      'Rework van het persoonlijke SK-logo plus een merkteken voor een archviz-project, gedocumenteerd in brandbookpagina’s met regels voor clear space, kleur en misbruik.',
    imageAlt: 'Brandbookpagina met het herwerkte persoonlijke SK-logo',
    sector: 'Persoonlijk merk',
    services: 'Logo design, Huisstijl',
    caseStudy: {
      challenge:
        'Het persoonlijke logo herwerken en een archviz-merkteken maken, en beide documenteren zodat het gebruik consistent blijft.',
      approach:
        'Ik herbouwde de merktekens, verkende toepassingen over meerdere artboards en stelde brandbookpagina’s samen voor clear space en misbruikregels.',
      result:
        'Een brandbookbasis die persoonlijke en projectidentiteit consistent houdt over alle touchpoints.',
      role: 'Identiteit & brandrichtlijnen',
      deliverables: ['Logo rework', 'Archviz-logo', 'Brandbookpagina’s'],
    },
  },
  38: {
    title: 'Charlie Chaplin film voice-over edit',
    description:
      'Filmproject uit het middelbaar: een Charlie Chaplin-clip met een eigen voice-overperformance, afgewerkt in Premiere en After Effects.',
    imageAlt: 'Still uit de Charlie Chaplin film voice-over edit',
    sector: 'Film',
    services: 'Voice-over',
    caseStudy: {
      challenge:
        'Voor een filmproject in het middelbaar een Charlie Chaplin-stuk kiezen en er een eigen voice-overperformance bij leveren.',
      approach:
        'Ik selecteerde de clip, schreef en nam mijn eigen voice-over op en werkte de montage af in Premiere / After Effects.',
      result:
        'Een afgewerkte hommage-edit die klassieke cinema combineert met een persoonlijke gesproken laag.',
      role: 'Voice-over & montage',
      deliverables: ['Voice-over', 'Gemonteerde film', 'Geluidsmix'],
    },
  },
  39: {
    title: 'SK Design portfoliowebsite & merksysteem',
    description:
      'Eigen build van skdesign.be: identiteitssysteem, conversiegerichte UX, motion, werkarchief en insights — live bewijs van brand, web en craft samen.',
    imageAlt: 'Screenshot van de homepage van de SK Design portfoliowebsite',
    sector: 'Persoonlijk merk / studio',
    services: 'Webdesign, Huisstijl, Motion, Front-end',
    caseStudy: {
      challenge:
        'Als designer-developer had ik een portfolio nodig dat het werk én het proces verkoopt — geen templategrid met een logo erop geplakt. Het moest ook branding, motion, 3D en webcases onder één heldere identiteit dragen.',
      approach:
        'Ik vertrok van het SK-merkteken en het cream/ink/orange-systeem, ontwierp daarna een conversion-first homepage, structureerde de werkpagina’s met casenarratief en bouwde de front-end zelf in React. Insights en brand guidelines trekken diezelfde stem door, voorbij projectstills.',
      result:
        'Een eigen studiosite die tegelijk case study en product is: live op skdesign.be, met gedocumenteerde merkregels en ruimte om te groeien met nieuw werk en nieuwe teksten.',
      role: 'Brand, UX, motion & front-end build',
      deliverables: [
        'Huisstijl',
        'Websitedesign & build',
        'Case-systeem voor werk',
        'Brand guidelines',
        'Insights-content',
      ],
    },
    relatedLinks: { label: 'Brand guidelines' },
  },
  40: {
    title: 'Geanimeerde posterreeks — skate, monk en klimmen',
    description:
      'Drie posters in printstijl tot leven gebracht als korte loops — skate, monk en klimmen — elk met eigen ritme, typografie en kleur, gemaakt om te werken als still én als clip.',
    teaser:
      'Poster motion-reeks: skate-, monk- en klimloops die de printcompositie behouden en er getimede typografie en kleur aan toevoegen.',
    imageAlt: 'Still uit de geanimeerde skateposter uit een motionreeks van drie posters',
    sector: 'Cultuur en sport',
    services: 'Motion design, Posteranimatie, Art direction',
    caseStudy: {
      challenge:
        'Drie posterconcepten — skatecultuur, een monk-stuk en klimmen — omzetten naar motion zonder de printread van typografie, uitsnede en kleur te verliezen.',
      approach:
        'Ik behandelde elke poster als een loop: compositie vasthouden, dan typografie, textuur en kleur timen zodat skate snel aanvoelt, het monk-stuk stil blijft en klimmen spanning houdt.',
      result:
        'Een posterreeks van drie clips die werkt als wandgrafiek én als social- of showreel-motion, vanuit dezelfde art direction.',
      role: 'Motion design & art direction',
      deliverables: ['Skate-posterloop', 'Monk-posterloop', 'Klim-posterloop'],
    },
    relatedLinks: { label: 'Motion design' },
  },
  41: {
    title: 'SaaS product motion explainer',
    description:
      'Korte productloop voor een SaaS-interface — UI-motion die de waarde in enkele seconden leesbaar maakt, gebouwd voor landingspagina’s, ads en onboarding.',
    teaser:
      'Product explainer in motion: een SaaS UI-loop die de flow verkoopt in plaats van een statische screenshot.',
    imageAlt: 'Still uit de UI-animatie van de SaaS product motion explainer',
    sector: 'Software / product',
    services: 'Product motion, UI-animatie, Explainer',
    caseStudy: {
      challenge:
        'Een SaaS-product had motion nodig die toont wat het product doet — geen decoratieve logo sting en geen stille schermopname.',
      approach:
        'Ik zette de interface op als getimede explainer: hiërarchie, cursor- en UI-beats en copy, zodat de loop in minder dan twintig seconden als productverhaal leest.',
      result:
        'Een herbruikbare productclip voor web, ads en onboarding die de SaaS-flow duidelijk maakt zonder voice-over.',
      role: 'Product motion design',
      deliverables: ['Explainer-loop', 'UI-animatie', 'Web-klare export'],
    },
    relatedLinks: { label: 'Motion design' },
  },
  42: {
    title: 'World Cup motion opener en goalsequentie',
    description:
      'Sportmotion in broadcast-stijl voor World Cup 2026: een titelopener en een goalbeat — typografie, pacing en impact gebouwd voor intropakketten en highlightcuts.',
    teaser:
      'World Cup 2026 motion: opener plus goalsequentie in broadcast-sporttaal.',
    imageAlt: 'Still uit de World Cup motion opener in broadcast-stijl',
    sector: 'Sport / broadcast',
    services: 'Motion design, Broadcast opener, Sequentiedesign',
    caseStudy: {
      challenge:
        'Sportmotion moet meteen raken — een opener die aanvoelt als een broadcast-ident, en daarna een goalbeat met genoeg impact om in highlights te snijden.',
      approach:
        'Ik splitste het stuk in twee sequenties: een World Cup-intro voor titelenergie, daarna een goal sting met strakkere timing, typografie en hit-frames voor het scoremoment.',
      result:
        'Een pakket van twee clips dat een reel kan openen of als opener en goalpunctuatie in een langere sportedit kan zitten.',
      role: 'Motion design',
      deliverables: ['Broadcast opener', 'Goalsequentie', 'Showreel-cuts'],
    },
    relatedLinks: { label: 'Motion design' },
  },
};

export default projectsNl;
